export default __webpack_public_path__ + "static/media/chatApp.f3427c5a.png";